import React, { Suspense } from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import parse from 'html-react-parser';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';

import { VDSModal } from '../../../../common/Modal/VDSModal';
import { FWAContainer, Row, Col as VDSCol } from '../../../../common/FWAContainer';
import '../shipping.css';
// import { getThrottleKeys } from '../../../../common/Helpers/taggingHelper';
import { store } from '../../../../../configureStore';
import Notification from '../../../../common/Notification/redesign/index';
import Loader from '../../../../common/Loader/index';
import MiniCart from '../../../../common/MiniCart/redesign';
import {
  isLoggedIn,
  pdcAEMCheck,
  renderHTML,
  getUrlName,
  getFlowType,
  // isWHW,
  // isWHWISPUFlag,
  isWHWPhase2Flag,
  getPageName,
  isShippingTabEnabled,
  isExpressCheckout,
  // isMobile,
} from '../../../../common/Helpers/index';
import { checkCartidAndLQResponse, redirectToHomePage } from '../../../../common/Helpers/commonLog';
import AsyncComponent from '../../../../common/AsyncComponent/index';

import { nonDesktopQuery } from '../shippingStyles';
import { desktopQuery, Margin } from '../../../../common/styles';
import { commonErrors } from '../../../../common/Helpers/constants';
import { getChannelId } from '../../../../../services/HttpService';
import CallCradleAPI from '../../../../common/RequestAPI';
import DesktopCart from '../../../../NextGen/OrderSummary/DesktopCart';
// import StickyCart from '../../../../NextGen/OrderSummary/StickyCart';

const ISPU = AsyncComponent(() => import('../../../../../pages/ShippingInfo/containers/web/ISPU'));

const Col = styled(VDSCol)`
  ${({ styles }) => styles}
`;

export default class ShippingInfo extends Container {
  constructor(props) {
    super(props);

    checkCartidAndLQResponse('shippingInfo');
    window.addEventListener('DOMContentLoaded', () => {});
    this.handleLoad = this.handleLoad.bind(this);
    this.modalChanged = this.modalChanged.bind(this);
  }

  componentDidMount() {
    this.props.getCheckOutDetails({ paymentOptions: true, cart: true, shippingOptions: true });
    this.props.fetchSMSEnabledDevices();
    window.addEventListener('load', this.handleLoad);
    if (isLoggedIn()) {
      const pageName = getUrlName(window.location.pathname);
      CallCradleAPI('FWA_Shipping', pageName);
    }
    if (this.props?.zipcode) {
      store.dispatch({ type: 'ISPU_ZIPCODE', response: this.props?.zipcode });
    }

    // const { excludeIndirect } = window.vzFlags || {};
    // const postData = {
    //   data: {
    //     zipCode: this.props.zipcode,
    //     pageId: 'checkout',
    //     range: 15,
    //     showOnlyAvailableStores: true,
    //     excludeIndirect,
    //   },
    // };
    // if (this.props?.zipcode && (!isWHW() || (isWHW() && isWHWISPUFlag()))) {
    //   const pageLoad = true;
    //   this.props.getISPUStores(postData, pageLoad);
    //   // this.props.getISPUStores(postData);
    // }
    document.title = 'Verizon Wireless';

    if (this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0) {
      store.dispatch({ type: 'CLEAR_CREDIT_CHECK_RESPONSE' });
    }
    // this.props.getDetailsFromApi();
    this.props.showCart(false);
    store.dispatch({ type: 'RESET_ISPU_MODAL' });
    this.setState({
      selectedShippingOption: this.props.selectedShippingOption,
    });
    const data = {
      pageName: 'shipping',
    };
    if (!isLoggedIn() && pdcAEMCheck()) {
      this.props.updatePdc(data);
    }
    store.dispatch({ type: 'CEF_SHIPPING_INFO_ERROR', response: false, errorMessage: null });
    // this.update();
  }

  componentDidUpdate() {
    if (!this.state.isTaggingCompleted) {
      this.invokeTaggingForTagging(this.props?.throttleValue || '');
    }
    if (this.props.removedWHWPlus && this.state.contButtonSelected) {
      this.submitISPUShippingAPI();
      if (this.props.selectedExpressCheckout && Object.keys(this.props.selectedExpressCheckout)?.length > 0) {
        store.dispatch({ type: 'EXPRESS_STORE_UPDATED', response: null });
      }
    }
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
    // when createProfile call is done, banner gets displayed, register it as banner displayed if user won't click close button in banner.
    if (this.props.universalProfileCreationStatus) this.props.universalProfileBannerDisplayed();
  }

  invokeTaggingForTagging = () => {
    // const shippingThrottleKeys = getThrottleKeys(this.props?.cradleResponseDetails, 'FWA_Shipping');
    // if (shippingThrottleKeys && shippingThrottleKeys.length) {
    //   this.props.invokeTaggingAPI({ throttleKey: shippingThrottleKeys, isFromShipping: "Y" });
    //   this.setState({ isTaggingCompleted: true });
    // }
    // else{
    this.props.invokeTaggingAPI();
    this.setState({ isTaggingCompleted: true });
    // }
  };

  updateFromISPU = (isUpdated) => {
    if (isUpdated) {
      this.setState(() => ({
        openIspuModal: false,
      }));
    } else {
      this.setState(() => ({
        selectedShippingOption: {},
        openIspuModal: false,
      }));
    }
    store.dispatch({ type: 'RESET_ISPU_MODAL' });
  };

  getStoreDetails = (selectedStore) => {
    if (selectedStore) {
      this.setState({ selectedStore });
      store.dispatch({ type: 'RESET_ISPU_MODAL' });
      this.setState({ showISPUWHWModal: true });
    }
  };

  addToCart = () => {
    store.dispatch({ type: 'LOADING_DONE', response: false });
    const oddOnList = [];
    const cartData = this.props?.getCheckOutDetailsState?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter(
      (obj) => obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
    );

    const type = cartData[0]?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus') ? 'whwServices' : '';
    if (cartData[0]?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus')) {
      const whwProdId = cartData[0] && cartData[0].sorId ? cartData[0].sorId : cartData[0].visFeatureCode;
      const whwProdName = cartData[0].featureDesc;
      const whwQty = '1';
      const pageName = getPageName();

      const whwData = {
        addWHWPlan: {
          whwProdId,
          whwQty,
          pageName,
        },
      };

      if (whwProdName) {
        whwData.prodName = whwProdName;
      }
      this.props.postAddToCart(whwData, type, oddOnList, 'addToCart', 'shipping');
      // eventDispatcher('addToCart', whwData);
      // updateEventInfo('scAdd');
    }
  };

  submitISPUShippingAPI = () => {
    if ((this.props.removedWHWPlus && this.state.selectedStore) || this.props.selectedExpressCheckout) {
      this.props.updateISPUShippingOption({
        homePhoneAdded: this.props.homePhoneAdded,
        locationCode: this.state.selectedStore
          ? this.state.selectedStore?.netaceLocationCode
          : this.props?.selectedExpressCheckout
            ? this.props?.selectedExpressCheckout?.netaceLocationCode
            : '',
        purchasePath: this.props.purchasePath,
        lineLevelShipment: this.props.lineLevelShipment,
        lineLevelShipmentSelectedLineSequenceNumber: this.props.lineLevelShipmentSelectedLineSequenceNumber,
        selectedOption: this.props.selectedOption,
        storeInfo: {
          storeName: this.props?.selectedExpressCheckout ? this.props?.selectedExpressCheckout?.storeName : this.state?.selectedStore?.storeName,
          storeAddress: this.props?.selectedExpressCheckout
            ? this.props?.selectedExpressCheckout?.storeAddress
            : this.state.selectedStore?.storeAddress,
          zipcode: this.props?.selectedExpressCheckout ? this.props?.selectedExpressCheckout?.zipCode : this.state.selectedStore?.zipCode,
          distance: this.props?.selectedExpressCheckout ? this.props?.selectedExpressCheckout?.distance : this.state.selectedStore?.distance,
          id: this.props?.selectedExpressCheckout ? this.props?.selectedExpressCheckout?.id : this.state.selectedStore?.id,
        },
        isSelectedFromISPUModal: isShippingTabEnabled(),
        cradleResponseDetails: this.props.cradleResponseDetails,
      });
      store.dispatch({ type: 'REMOVE_WHWPLUS' });
      // if ( this.props.selectedExpressCheckout && Object.keys(this.props.selectedExpressCheckout)?.length > 0) {
      // store.dispatch ({type: 'EXPRESS_STORE_UPDATED', response: null});
      // }
      this.setState({ contButtonSelected: false });
      this.setState({ showISPUWHWModal: false });
    }
  };

  modalChanged = (state) => {
    if (!state) {
      store.dispatch({ type: 'RESET_ISPU_MODAL' });
      const { shippingCode, storeinfo } = this.props.cartDetails?.cartDetailsJson?.shippingDetails?.[0] || {};
      if (shippingCode && !storeinfo) {
        const shippingOptions = this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions;
        const previousSelection = shippingOptions?.length ? shippingOptions.find((optionRef) => optionRef.shippingOptionId === shippingCode) : null;
        if (previousSelection) {
          this.props.saveSelectedOption(previousSelection);
        }
      }
    }
  };

  availableStores = (storeList) => {
    if (!storeList?.length) {
      return false;
    }
    return storeList.filter((pickupStore) => (pickupStore?.items?.item || []).every((stockData) => stockData?.quantity)).length;
  };

  render() {
    const carthasWHWPlus =
      this.props?.getCheckOutDetailsState?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
        obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
      );

    const selectedFromExpress = this.props.selectedExpressCheckout && Object.keys(this.props.selectedExpressCheckout)?.length;
    const isInvalidAddressError = this.props.isInvalidAddressError || false;
    const isApiError = this.props.apiFailureError;
    const { AUTH_CODE_VERIFICATION_ERROR } = this.props;
    const isAddressChangeRequired = this.props?.addressChangeRequired;
    // const isaddressChangeRsnCode = this.props?.addressChangeRsnCode;
    // eslint-disable-next-line prefer-destructuring, prefer-destructuring
    // const addressChangeRequiredCodes = this.props.addressChangeRequiredCodes;
    // const addressChangeRsnMsg = addressChangeRequiredCodes?.[isaddressChangeRsnCode];
    const newAddressRequiredMessage =
      this.props.newAddressRequiredMessage || 'The shipping address associated with your account is invalid. Please enter a new shipping address.';

    let homePhoneAdded = false;
    const ctaMarkers = ['ispuContactEditCTA', 'ispuCTA', 'shippingAddressCTA_2', 'shippingInfoEditCTA'];
    const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
    if (homePhoneResponse && homePhoneResponse.length > 0) {
      homePhoneAdded = true;
    }
    const notificationProps = {
      renderIf: false,
      title: '',
      type: 'warning',
      serviceInfo: '',
      subtitle: '',
    };
    const notificationPropsForOTP = {
      renderIf: false,
      title: '',
      type: 'warning',
      serviceInfo: '',
      subtitle: '',
    };
    // if (
    //   isAddressChangeRequired &&
    //   isaddressChangeRsnCode &&
    //   isaddressChangeRsnCode !== '' &&
    //   isaddressChangeRsnCode !== undefined &&
    //   addressChangeRsnMsg !== undefined
    // ) {
    //   notificationProps.renderIf = true;
    //   notificationProps.title = addressChangeRsnMsg;
    //   notificationProps.serviceInfo = this.props?.shippingServiceInfo;
    // }
    if (
      this.props.shippingInfoError &&
      !isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions) &&
      !this.props.shippingInvalidCaseError
    ) {
      notificationProps.renderIf = true;
      notificationProps.title = renderHTML(this.props.shippingInfoNtfyMsg || commonErrors?.systemError);
      notificationProps.serviceInfo = this.props?.shippingServiceInfo;
    } else if (
      ((isInvalidAddressError && !isAddressChangeRequired) || isApiError || (isAddressChangeRequired && !this.props?.addressChangeRsnCode)) &&
      !this.props.shippingInvalidCaseError
    ) {
      notificationProps.renderIf =
        ((isInvalidAddressError && !isAddressChangeRequired) || isApiError || (isAddressChangeRequired && !this.props?.addressChangeRsnCode)) &&
        !this.props.shippingInvalidCaseError;
      const addressErrorMessage = this.props?.updateShippingAdressResponse?.errors?.[0]?.message;
      notificationProps.title = isAddressChangeRequired ? newAddressRequiredMessage : addressErrorMessage || commonErrors?.systemError;
      notificationProps.serviceInfo = this.props?.shippingServiceInfo;
    } else if (this.props.shippingInvalidCaseError) {
      notificationProps.renderIf = this.props?.shippingInvalidCaseError;
      notificationProps.title = parse(commonErrors?.transactionExpired || '');
      notificationProps.serviceInfo = this.props?.shippingServiceInfo;
    } else if (
      this.props.shippingInfoDetails &&
      this.props.shippingInfoDetails?.lines &&
      this.props.shippingInfoDetails?.lines?.[0] &&
      this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions)
    ) {
      notificationProps.renderIf =
        this.props.shippingInfoDetails &&
        this.props.shippingInfoDetails.lines &&
        this.props.shippingInfoDetails.lines[0] &&
        this.props.shippingInfoDetails.lines[0].shippingOptions;
      notificationProps.title = commonErrors?.systemError;
    }
    // console.log("HELLO", AUTH_CODE_VERIFICATION_ERROR);
    if (AUTH_CODE_VERIFICATION_ERROR) {
      notificationPropsForOTP.renderIf = AUTH_CODE_VERIFICATION_ERROR;
      notificationPropsForOTP.title = AUTH_CODE_VERIFICATION_ERROR;
    }

    const link = document.getElementById('transactionExpiryLink');
    if (link) {
      link.addEventListener('click', redirectToHomePage);
    }

    // to check If api is success;
    // const shippingInfoComponents = this.childComponents.filter(
    //   (item) => (item.key.indexOf('/shippingOptions') >= 0),
    // );
    const shippingInfoComponents = this.childComponents.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/miniCartFunctionalDueToday') >= 0 ||
          item.key.indexOf('/miniCartFunctionalDueMonthly') >= 0
        ),
    );
    const miniCartComponents = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    const miniCartComponentsFunc = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartFunctionalDueToday') >= 0 || item.key.indexOf('/miniCartFunctionalDueMonthly') >= 0,
    );
    const miniCartRef = miniCartComponentsFunc?.length ? miniCartComponentsFunc : miniCartComponents;

    return (
      <>
        {this.props?.openISPUModal && (
          <VDSModal opened onOpenedChange={this.modalChanged} contentContainer="ispuModalContainer" disableOutsideClick>
            <ModalBody>
              <Suspense fallback={<Loader active />}>
                <Margin left="10px" right="10px">
                  <ISPU
                    updateFromISPU={this.updateFromISPU}
                    getStoreDetails={this.getStoreDetails}
                    cradleResponseDetails={this.props.cradleResponseDetails}
                    getISPUStores={this.props.getISPUStores}
                    shipmentItems={this.props.selectedShippingOption}
                    selectedOption={this.state.selectedShippingOption}
                    lineLevelShipment={false}
                    isSplitShipment={false}
                    lineLevelShipmentSelectedLineSequenceNumber=""
                    updateISPUShippingOption={this.props.updateISPUShippingOption}
                    homePhoneAdded={homePhoneAdded}
                    // isFetching={isFetching}
                  />
                </Margin>
              </Suspense>
            </ModalBody>
          </VDSModal>
        )}

        {isWHWPhase2Flag() && (this.state.showISPUWHWModal || selectedFromExpress > 0) && carthasWHWPlus && (
          <Modal
            surface="light"
            opened
            onOpenedChange={(val) => {
              if (!val) {
                this.setState({ showISPUWHWModal: val });
              }
            }}
          >
            <ModalTitle>{this.props.whwISPUModalTitle}</ModalTitle>
            <ModalBody>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.whwISPUModalBody,
                }}
              />
            </ModalBody>
            <ModalFooter
              buttonData={{
                primary: {
                  width: '226px',
                  children: 'Continue',
                  onClick: () => {
                    this.addToCart();
                    this.setState({ contButtonSelected: true });
                    this.setState({ showISPUWHWModal: false });
                  },
                },
                close: {
                  width: '226px',
                  children: 'Other shipping options',
                  onClick: () => {
                    store.dispatch({ type: 'OTHER_OPTIONS_SELECTED' });
                    this.setState({ showISPUWHWModal: false });
                  },
                },
              }}
            />
          </Modal>
        )}
        <Notification {...notificationProps} />
        <Notification {...notificationPropsForOTP} />
        <FWAContainer topBufferAuto enableLiveSupport title={this.props.title}>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 11, desktop: 8 }} styles={desktopQuery('flex-basis: 67%; max-width: 67%;')}>
              {shippingInfoComponents}
            </Col>
            {/* {isExpressCheckout() && isMobile() && <StickyCart
                  btnName="Continyeee"
                  // callBtnMethod= ()
                />} */}
            <Col
              colSizes={{ mobile: 0, tablet: 1, desktop: 4 }}
              styles={`${nonDesktopQuery('display:none;')}${desktopQuery('max-width: 33.3%;margin-left: -0.3%;margin-top:6rem;')}`}
            >
              {isExpressCheckout() && <DesktopCart />}
              {!isExpressCheckout() && (
                <MiniCart
                  topMarginStyle="26"
                  miniCartComponents={miniCartRef}
                  showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                  iscartVisible={this.props.cartDetails.isCartVisible}
                />
              )}
              {ctaMarkers.map((markerId) => (
                <div id={markerId} />
              ))}
            </Col>
          </Row>
        </FWAContainer>
      </>
    );
  }
}

ShippingInfo.propTypes = {
  invokeTaggingAPI: PropTypes.func,
};
